/* eslint-disable react/no-array-index-key */
import { Modal, Table, Button } from 'appkit-react';

import ColumnChart from './ColumnChart';
import '../styles/DetailsModal.scss';

const DetailsModal = ({ showDetailsModal, setShowDetailsModal, colMatchData }) => {
    const columns = [
        {
            Header: 'Source',
            accessor: 'sourceCol',
            minWidth: 80,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Datatype',
            accessor: 'dataTypeSrc',
            minWidth: 50,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Target',
            accessor: 'targetCol',
            minWidth: 80,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Datatype',
            accessor: 'dataTypeTrgt',
            minWidth: 50,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Score',
            Cell: ({ original, index }) => (
                <div className="menu-icon">
                    <ColumnChart percent={original.colMatchPercent} index={index} />
                    <p className="highlighted">{`${original.colMatchPercent}%`}</p>
                </div>
            ),
            minWidth: 150,
            resizable: true,
            sortable: true,
        },
    ];

    return (
        <Modal
            className="form-modal true-comply-data-relationship-details_modal"
            visible={showDetailsModal}
        >
            <div className="true-comply-data-relationship-details_modal_headsection">
                <p>COLUMN MATCH DETAILS</p>
                <span onClick={() => setShowDetailsModal(false)} className="appkiticon icon-close-outline" aria-hidden="true" />
            </div>
            <div className="true-comply-data-relationship-details_modal_bodysection">
                <Table
                    data={colMatchData}
                    columns={columns}
                    showPagination
                    striped={false}
                    defaultPageSize={10}
                    sortable
                    resizable
                    noDataText="No Data ..!!!"
                />
            </div>
            <div className="true-comply-data-relationship-details_modal_footersection">
                <Button size="lg" onClick={() => setShowDetailsModal(false)} aria-hidden="true">OK</Button>
            </div>
        </Modal>
    );
};

export default DetailsModal;
